/**
 * GASTRIC RESOLVER (MEV5)
 * Mechanism: Gastric Emptying & Duodenal Feedback
 * Standards: Elashoff (1982), Lin et al. (1996)
 */

import { V5PhysiologicalState as PhysiologicalState, ClinicalFraction } from '../types';

export const GastricResolver = {
    
    /**
     * Calculates the grams of a specific fraction leaving the stomach per minute.
     */
    compute(
        state: PhysiologicalState, 
        fraction: ClinicalFraction, 
        specificRate: number,
        lagMultiplier: number = 1.0
    ): number {
        const comp = state.fractions[fraction];
        if (comp.stomach <= 0) return 0;

        // 1. DUODENAL BRAKE (Fat feedback)
        const fatInGut = state.fractions.lipids.gut;
        const brakeFactor = Math.max(0.4, 1 - (fatInGut / 50));

        // 2. FLOW SELECTION
        let emptied = 0;
        if (state.gastricVolume > 0 && state.gastricVolume < 20) {
            // TERMINAL MMC (Linear sweep)
            const mmcTotalRate = 0.1; 
            const share = comp.stomach / state.gastricVolume;
            emptied = Math.min(comp.stomach, mmcTotalRate * share);
        } else if (state.gastricVolume >= 20) {
            // EXPONENTIAL FLOW (MPE Model)
            // Includes nutrient-specific velocity and the Trituration Lag
            emptied = comp.stomach * specificRate * brakeFactor * lagMultiplier;
        }

        return emptied;
    }
};
